import { VIEW_FIELDS } from './defaultForm'

// PCB参数处理

// 产品类别判断
export const isBoardType = board_type => ({
  // FR-4
  isFr4: board_type === 'FR-4',
  // FPC
  isFpc: board_type === 'FPC',
  // 罗杰斯高频板
  isRogers: board_type === 'ROGERS',
  // FR-4 || 罗杰斯高频板
  isFr4OrRogers: ['FR-4', 'ROGERS'].includes(board_type),
  // 铝基板
  isAlu: board_type === 'ALU',
  // 铜基板
  isCopper: board_type === 'COPPER',
})

// 是否显示判断
export const isShowPcbParams = params => {
  const isShowBoardType = isBoardType(params.board_type)

  // 阻焊覆盖
  const isShowCover = () => {
    // 铝基板：铝基板结构 == 芯板为铝基,顶底层为走线
    if (isShowBoardType.isAlu) {
      return params.aluminium_board_type == 2
    }
    // 铜基板：铜基板结构 == 芯板为铜基,顶底层为走线
    if (isShowBoardType.isCopper) {
      return params.copper_board_type == 2
    }
    // 其他板材
    return true
  }

  return {
    ...isShowBoardType,
    // 是否显示混压类型
    hybrid_type: isShowBoardType.isRogers,
    // 是否显示板材型号
    board_model: isShowBoardType.isRogers,
    // 是否显示HDI(盲埋孔)
    blind: isShowBoardType.isFr4,
    // 是否显示板材
    board: isShowBoardType.isFr4 || isShowBoardType.isAlu,
    // 是否显示TG值
    board_tg: params.blayer > 2,
    // 是否显示连片类型
    delivery_sub_units: params.units == 3,
    // 是否显示拼板规则
    layout: params.units == 2,
    // 是否显示工艺边框
    sidewidth: params.units == 2,
    // 是否显示内层铜厚
    insidecopper: !isShowBoardType.isAlu && params.blayer > 2,
    // 是否显示沉金厚度
    cjh: params.spray == '沉金',
    // 是否显示层压顺序
    overlay_type: !isShowBoardType.isAlu && !isShowBoardType.isCopper && params.blayer >= 4,
    // 是否显示叠层结构
    pressing: !isShowBoardType.isAlu && !isShowBoardType.isCopper && params.blayer > 2,
    // 是否显示报告形式
    report_type: ['出货报告', '切片报告', '阻抗报告'].some(i => params.report.includes(i)),
    // 是否显示拼板后尺寸
    pcb_size: params.units != 3,
    // 是否显示压接孔
    press_fit_hole: !isShowBoardType.isAlu && !isShowBoardType.isCopper && params.blayer >= 4,
    // 是否显示混压类型
    hybrid_type: isShowBoardType.isRogers,
    // 是否显示蓝胶
    blue_glue: isShowBoardType.isRogers,
    // 是否显示碳油
    carbon_oil: isShowBoardType.isRogers,
    // 是否显示内标签
    inner_box_label: isShowBoardType.isFr4,
    // 是否显示内包装标签备注
    label_remark: params.inner_box_label == 0,
    // 是否显示少数处理方式
    lack_handle_type: isShowBoardType.isFr4,
    // 是否显示品质赔付方式
    insurance_type: isShowBoardType.isFr4,
    // 是否显示周期格式
    period_format: params.has_period != 2,
    // 是否显示工程师信息
    engineer_id: params.eq_notice == 2,
    // 是否显示发票抬头
    bill_id: !!params.invoice,
    // 是否显示导热系数
    heat_factor: isShowBoardType.isAlu || isShowBoardType.isCopper,
    // 是否显示板材耐压值
    withstand_value: isShowBoardType.isAlu && params.blayer == 1,
    // 是否显示阻焊覆盖
    cover: isShowCover(),
    // 是否显示盘中孔
    via_in_pad: !isShowBoardType.isAlu && !isShowBoardType.isCopper,
    // 是否显示阻抗
    impendance: ((isShowBoardType.isFr4 || isShowBoardType.isFpc) && params.blayer > 1) || isShowBoardType.isRogers,
    // 是否显示手指斜边
    beveledge: !isShowBoardType.isAlu && !isShowBoardType.isCopper,
    // 是否显示半孔
    bankong: !isShowBoardType.isAlu && !isShowBoardType.isCopper,
    // 是否显示包边
    baobian: !isShowBoardType.isAlu && !isShowBoardType.isCopper,
    // 是否显示成型方式
    forming_method: isShowBoardType.isAlu || isShowBoardType.isCopper,
    // 是否显示沉头孔
    countersunk_hole: isShowBoardType.isAlu || isShowBoardType.isCopper,
    // 是否显示铜基结构
    copper_structure: isShowBoardType.isCopper,
  }
}

// 计算板子拼板尺寸
export const computePcbSize = params => {
  const { 
    width: bwidth, // 单片宽
    length: blength, // 单片长
    units, // 出货形式
    layoutx, // 列
    layouty, // 行
    sidewidth, // 工艺边宽度
    sidedirection, // 工艺边方向 
    pcs_cols_space, // 列距
    pcs_row_space, // 行距
    gap_cols_space, // 工艺边左右间距
    gap_row_space, // 工艺边上下间距
  } = params
  let width = Number(bwidth), length = Number(blength)
  // 出货形式 = 连片(华秋代拼)
  if (units == 2) {
    // 总行距
    const rowSpaceTotal = (pcs_row_space || 0) * ((layouty || 1) - 1) / 10
    // 总列距
    const colSpaceTotal = (pcs_cols_space || 0) * ((layoutx || 1) - 1) / 10

    width = width * (layouty || 1) + rowSpaceTotal
    length = length * (layoutx || 1) + colSpaceTotal
  }
  // 出货形式 != 连片(按文件)  需要加上工艺边
  if (units != 3) {
    const sidewidthTotal = sidewidth * 2 / 10
    // 上下工艺边间距
    const sideRowSpace = (gap_row_space || 0) * 2 / 10
    // 左右工艺边间距
    const sideColSpace = (gap_cols_space || 0) * 2 / 10

    // 上下 || 四边
    if (sidedirection == 'X' || sidedirection == 'XY') {
      width = width + sidewidthTotal + sideRowSpace
    }
    // 左右 || 四边
    if (sidedirection == 'Y' || sidedirection == 'XY') {
      length = length + sidewidthTotal + sideColSpace
    }
  }
  
  return { width: +width.toFixed(2), length: +length.toFixed(2) }
}

// 计算板子面积
export const computeAreas = params => {
  const { length, width } = computePcbSize(params)
  return length * width * params.bcount / 10000
}

// 连片数量换算为单片数量
export const pcsNumForSet = params => {
  const { layoutx, layouty, bcount } = params
  return layoutx * layouty * bcount || 0
}

// PCB参数格式化
export const formatPcbParams = (pcbParams, otherParams = {}) => {
  const params = { ...pcbParams, ...otherParams }
  const isShow = isShowPcbParams(params)
  // 当TG值隐藏时，清空TG值
  // if (!isShow.board_tg) {
  //   params.board_tg = ''
  // }
  // 出货形式 != 连片(华秋代拼)
  if (params.units != 2) {
    // 置空连接方式
    params.panelize_method = ''
  }
  // 连片类型
  if (!isShow.delivery_sub_units) {
    params.delivery_sub_units = ''
  }
  // 拼板规则隐藏时，默认为1
  if (!isShow.layout) {
    params.layoutx = 1
    params.layouty = 1
  }
  // 工艺边框
  if (!isShow.sidewidth) {
    params.sidedirection = '无'
    params.sidewidth = 0
  }
  // 当内层铜厚隐藏时，传 0
  if (!isShow.insidecopper) {
    params.insidecopper = 0
  }
  // 当板材耐压值隐藏时，传 ''
  if (!isShow.withstand_value) {
    params.withstand_value = ''
  }
  // 当阻焊覆盖隐藏时，传 ''
  if (!isShow.cover) {
    params.cover = ''
  }
  // 当沉金厚度隐藏时，传 0
  if (!isShow.cjh) {
    params.cjh = 0
  }
  // 层压顺序
  if (!isShow.overlay_type) {
    params.overlay_type = ''
    params.overlay_seq = ''
  } else {
    params.overlay_seq = params.overlay_type == 3 ? params.overlay_seq : ''
  }
  // 当叠层结构隐藏 或 为 无需求时，传 ''
  if (!isShow.pressing || params.pressing === '无需求') {
    params.pressing = ''
  }
  // 当报告形式隐藏时，传 0
  if (!isShow.report_type) {
    params.report_type = 0
  }
  // 当压接孔隐藏时，传 0
  if (!isShow.press_fit_hole) {
    params.press_fit_hole = 0
  }
  // 订单支付方式
  if (params.deduct_type == 2) {
    params.deduct_limit = ''
  }
  // 品质赔付方式为 标准赔付 时，清空 PCBA单片成本价
  if (params.insurance_type == 0) {
    params.insurance = ''
  }
  // 内标签
  if (params.inner_box_label != 1) {
    params.custom_id = ''
    params.custom_name = ''
  }
  // 内包装标签备注
  if (!isShow.label_remark) {
    params.label_remark = ''
  }
  // 当阻抗隐藏时，传 0
  if (!isShow.impendance) {
    params.impendance = 0
  }

  // 产品报告
  params.report = params.report.includes('无需') ? '' : params.report.join(',')

  // 叠层结构
  if (params.pressing.includes('__')) {
    const [pressing_computer_id, pressing] = params.pressing.split('__')
    params.pressing = pressing
    params.pressing_computer_id = pressing_computer_id
  } else {
    params.pressing_computer_id = ''
  }
  delete params.pressing_data

  // 少数处理方式
  if (params.lack_handle_type != 2) {
    // 少数处理方式 不等于 少数默认补料 时，清空相关参数
    params.lack_handle_number_type = ''
    params.lack_handle_number = ''
    params.lack_handle_number_unit = ''
    params.lack_handle_shipping_type = ''
  }

  // 罗杰斯
  if (isShow.isRogers) {
    // 混压类型 等于 混压时，TG值默认为 TG170，否则为空
    params.board_tg = params.hybrid_type == 2 ? 'TG170' : ''
  }

  // 后端要求不传
  delete params.side_width_left
  delete params.side_width_right
  delete params.side_width_top
  delete params.side_width_bot

  // 删除前端展示字段
  Object.keys(VIEW_FIELDS).forEach(key => delete params[key])

  return params
}

// PCB板子尺寸检验
const validatePcbSize = params => {
  const areas = computeAreas(params)
  const { length, width } = computePcbSize(params)
  const [minVal, maxVal] = [length, width].sort((a, b) => a - b)
  const { beveledge, spray, blayer } = params
  if (length > 0 && width > 0) {
    return [
      {
        key: 'length',
        flag: beveledge == 1 && ((length < 4 || length > 28) || (width < 4 || width > 28)),
        tips: '手指斜边工艺，加工尺寸长和宽需满足4-28CM区间，请重新调整参数',
        boardTypes: ['FR-4', 'ROGERS'],
        topWarning: true
      },
      {
        key: 'length',
        flag: length < 1 || width < 1,
        tips: '加工尺寸长和宽都不能小于1CM，请修改板子尺寸或调整工艺边尺寸',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER'],
        topWarning: true
      },
      {
        key: 'length',
        flag: blayer < 4 && (minVal > 60 || maxVal >= 70),
        tips: '单双面板我们暂时只支持70*60cm以内的订单，请调整尺寸',
        boardTypes: ['FR-4'],
        topWarning: true
      },
      {
        key: 'length',
        flag: blayer == 4 && (minVal > 50 || maxVal >= 70),
        tips: '4层板我们暂时只支持70*50cm以内的订单，请调整尺寸',
        boardTypes: ['FR-4'],
        topWarning: true
      },
      {
        key: 'length',
        flag: blayer > 4 && ((length > 40 && width > 40) || length > 50 || width > 50),
        tips: '多层板板长或板宽大小须小于 50*40，如有疑问请联系华秋工作人员',
        boardTypes: ['FR-4'],
        topWarning: true
      },
      {
        key: 'length',
        flag: blayer < 4 && ((length > 50 && width > 50) || length > 60 || width > 60),
        tips: '单双面板长和板宽不能同时超过50厘米，大小须小于 60*50，如有疑问请联系华秋工作人员',
        boardTypes: ['ROGERS'],
        topWarning: true
      },
      {
        key: 'length',
        flag: blayer >= 4 && ((length > 40 && width > 40) || length > 50 || width > 50),
        tips: '多层板板长或板宽大小须小于 50*40，如有疑问请联系华秋工作人员',
        boardTypes: ['ROGERS'],
        topWarning: true
      },
      {
        key: 'length',
        flag: spray !== 'OSP' && areas >= 5 && [length, width].every(i => i < 5),
        tips: '非OSP工艺，面积≥5㎡，加工尺寸不能小于5*5cm，请重新调整参数',
        boardTypes: ['FR-4', 'ROGERS'],
        topWarning: true
      },
      {
        key: 'length',
        flag: blayer == 1 && (minVal > 85 || maxVal > 149),
        tips: '板长或板宽大小须小于 149*85，请调整尺寸',
        boardTypes: ['ALU'],
        topWarning: true
      },
      {
        key: 'length',
        flag: blayer == 2 && params.aluminium_board_type == 1 && (minVal > 80 || maxVal > 90),
        tips: '板长或板宽大小须小于 90*80，请调整尺寸',
        boardTypes: ['ALU'],
        topWarning: true
      },
      {
        key: 'length',
        flag: blayer == 2 && params.aluminium_board_type == 2 && (minVal > 80 || maxVal > 115),
        tips: '板长或板宽大小须小于 115*80，请调整尺寸',
        boardTypes: ['ALU'],
        topWarning: true
      },
      {
        key: 'length',
        flag: minVal > 60 || maxVal > 90,
        tips: '板长或板宽大小须小于 90*60，请调整尺寸',
        boardTypes: ['COPPER'],
        topWarning: true
      },
    ]
  }
  return []
}
// PCB计价页下单校验
export const validatePcbQuote = params => {
  const isShow = isShowPcbParams(params)
  const { length, width } = computePcbSize(params)
  const valids = [
    {
      key: 'pcbfile',
      flag: !params.pcbfile, 
      tips: '请上传PCB文件',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'aluminium_board_type',
      flag: !params.aluminium_board_type, 
      tips: '请选择铝基板结构',
      boardTypes: ['ALU']
    },
    {
      key: 'copper_board_type',
      flag: !params.copper_board_type, 
      tips: '请选择铜基板结构',
      boardTypes: ['COPPER']
    },
    {
      key: 'board',
      flag: !params.board_brand, 
      tips: '请选择板材',
      boardTypes: ['FR-4', 'ROGERS', 'ALU']
    },
    {
      key: 'pbnum',
      flag: !params.pbnum, 
      tips: '请输入拼板款数',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'pbnum',
      flag: isNaN(Number(params.pbnum)) || Number(params.pbnum) <= 0 || Number(params.pbnum) % 1 !== 0, 
      tips: '拼板款数，需为1的正整数倍，请修改拼板款数',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER'],
      topWarning: true
    },
    {
      key: 'delivery_sub_units',
      flag: isShow.delivery_sub_units && !params.delivery_sub_units, 
      tips: '请选择连片类型',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'length',
      flag: isNaN(Number(params.length)) || Number(params.length) <= 0 || isNaN(Number(params.width)) || Number(params.width) <= 0, 
      tips: '请输入板子大小',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'layout',
      flag: isShow.layout && (!params.layoutx || !params.layouty), 
      tips: '请输入拼板规则',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'bcount',
      flag: params.bcount <= 0, 
      tips: '请选择板子数量',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'sidewidth',
      flag: () => {
        if (params.sidedirection == '无') return false
        if (params.dfm_sets) {
          // 有DFM拼板信息时，校验四边
          const dfmSets = JSON.parse(params.dfm_sets) || {}
          return ['side_width_top', 'side_width_bot', 'side_width_left', 'side_width_right'].some(key => {
            return dfmSets[key] > 0 && dfmSets[key] < 3
          })
        }
        return params.sidewidth < 3
      },
      tips: '工艺边框最小3mm',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER'],
      topWarning: true
    },
    {
      key: 'sidewidth',
      flag: () => {
        if (params.sidedirection == '无') return false
        if (params.dfm_sets) {
          // 有DFM拼板信息时，校验四边
          const dfmSets = JSON.parse(params.dfm_sets) || {}
          return ['side_width_top', 'side_width_bot', 'side_width_left', 'side_width_right'].some(key => {
            return dfmSets[key] * 10 % 5 != 0
          })
        }
        return params.sidewidth * 10 % 5 != 0
      }, 
      tips: '工艺边框仅支持0.5的倍数，比如3.5, 4 , 4.5',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER'],
      topWarning: true
    },
    {
      key: 'bheight',
      flag: !params.bheight, 
      tips: '请选择板子厚度',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'insidecopper',
      flag: isShow.insidecopper && !params.insidecopper, 
      tips: '请选择内层铜厚',
      boardTypes: ['FR-4', 'ROGERS', 'COPPER']
    },
    {
      key: 'spray',
      flag: () => {
        if (params.spray === 'OSP' && length > 0 && width > 0) {
          const [min, max] = [length, width].sort((a, b) => a - b)
          return min < 5 || max < 8
        }
        return false
      }, 
      tips: 'OSP工艺，加工尺寸长和宽不能小于8*5cm ，请重新调整参数',
      boardTypes: ['FR-4', 'ROGERS'],
      topWarning: true
    },
    {
      key: 'spray',
      flag: () => {
        if (params.spray === 'OSP' && length > 0 && width > 0) {
          const areas = computeAreas(params)
          return areas > 3 && params.spray == 'OSP' && params.cover == '过孔盖油'
        }
        return false
      },
      tips: '您当前选择的大于3平米的OSP工艺订单，阻焊覆盖不支持过孔盖油，需您重新调整参数。',
      boardTypes: ['FR-4', 'ROGERS'],
      topWarning: true
    },
    {
      key: 'spray',
      flag: isShow.press_fit_hole && params.press_fit_hole == 1 && !['沉金', 'OSP'].includes(params.spray),
      tips: '您当前选择的是有压接孔，请修改为沉金或OSP工艺。',
      boardTypes: ['FR-4', 'ROGERS'],
      topWarning: true
    },
    {
      key: 'overlay_type',
      flag: isShow.overlay_type && !params.overlay_type, 
      tips: '请选择层压顺序',
      boardTypes: ['FR-4', 'ROGERS']
    },
    {
      key: 'overlay_type',
      flag: isShow.overlay_type && params.overlay_type == 3 && !params.overlay_seq, 
      tips: '请填写层压顺序',
      boardTypes: ['FR-4', 'ROGERS']
    },
    {
      key: 'pressing',
      flag: isShow.pressing && !params.pressing, 
      tips: '请选择您需要的叠层结构',
      boardTypes: ['FR-4', 'ROGERS']
    },
    {
      key: 'beveledge',
      flag: params.beveledge == 1 && ((length < 4 || length > 28) || (width < 4 || width > 28)), 
      tips: '手指斜边工艺，加工尺寸长和宽需满足4-28CM区间，请重新调整参数',
      boardTypes: ['FR-4', 'ROGERS'],
      topWarning: true
    },
    {
      key: 'review_file',
      flag: !params.review_file && params.review_file !== 0, 
      tips: '请选择确认生产稿',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'has_period',
      flag: !+params.has_period, 
      tips: '请选择华秋标识和制造周期',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'period_format',
      flag: isShow.period_format && !+params.period_format, 
      tips: '请选择周期格式',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'user_stamp',
      flag: !params.user_stamp, 
      tips: '请选择客编',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'eq_notice',
      flag: !params.eq_notice, 
      tips: '请选择工程EQ确认方式',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'engineer_id',
      flag: isShow.engineer_id && (!params.engineer_id || params.engineer_id.length === 0), 
      tips: '请选择工程师信息',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'lack_handle_type',
      flag: !params.lack_handle_type && params.lack_handle_type !== 0, 
      tips: '请选择少数处理方式',
      boardTypes: ['FR-4']
    },
    {
      key: 'lack_handle_type',
      flag: params.lack_handle_type == 2 && !params.lack_handle_number_type, 
      tips: '请选择少数订单数量',
      boardTypes: ['FR-4']
    },
    {
      key: 'lack_handle_type',
      flag: params.lack_handle_type == 2 && params.lack_handle_number_type == 2 && params.lack_handle_number > params.bcount, 
      tips: '当前填写的少数数量大于订单数，请重新输入',
      boardTypes: ['FR-4'],
      topWarning: true
    },
    {
      key: 'report_type',
      flag: isShow.report_type && !params.report_type, 
      tips: '请选择报告形式',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'paper',
      flag: !params.paper, 
      tips: '请选择隔白纸',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'inner_box_label',
      flag: !params.inner_box_label && params.inner_box_label !== 0, 
      tips: '请选择内标签',
      boardTypes: ['FR-4']
    },
    {
      key: 'inner_box_label',
      flag: params.inner_box_label == 1 && !params.custom_id, 
      tips: '请选择内标签模板',
      boardTypes: ['FR-4']
    },
    {
      key: 'hq_pack',
      flag: isShow.hq_pack && !params.hq_pack && params.hq_pack !== 0,
      tips: '请选择纸箱要求',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'orderman_id',
      flag: !params.orderman_id, 
      tips: '请选择下单人信息',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'fhp',
      flag: params.fhp == 1 && !params.fhd_title, 
      tips: '请选择收据抬头',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'aid',
      flag: !params.aid, 
      tips: '请选择收货地址',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER'],
      topWarning: true
    },
    {
      key: 'express',
      flag: !params.express || +params.express === 0, 
      tips: '请选择快递公司',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'invoice',
      flag: !params.invoice, 
      tips: '请选择开票类型',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'bill_id',
      flag: isShow.bill_id && !params.bill_id, 
      tips: '请选择发票抬头',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'deduct_type',
      flag: !params.deduct_type, 
      tips: '请选择订单支付方式',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    {
      key: 'deduct_type',
      flag: params.deduct_type == 1 && !params.deduct_limit && !['0.00', '0', 0].includes(params.deduct_limit), 
      tips: '请填写自动扣款差额范围',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER'],
      topWarning: true
    },
    {
      key: 'is_need_smt',
      flag: !params.is_need_smt, 
      tips: '请选择是否需要我司做SMT',
      boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER']
    },
    ...validatePcbSize(params)
  ]

  return valids.filter(item => {
    if (item.boardTypes && !item.boardTypes.includes(params.board_type)) return false
    
    const flag = typeof item.flag === 'function' ? item.flag() : item.flag
    return flag
  })
}
